import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0d13cdac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification_bar" }

import { computed, ref } from "vue";

interface Props {
    notice: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeBar',
  props: {
    notice: { default: '' }
  },
  setup(__props: any) {

const props = __props

const noticeOut = ref<HTMLDivElement|null>(null);
const noticeInner = ref<HTMLDivElement|null>(null);

const aDuration = computed(() => {
    if (!noticeOut.value?.getBoundingClientRect || !noticeInner.value?.getBoundingClientRect) return 0;
    
    const outWidth = noticeOut.value.getBoundingClientRect().width;
    const innerWidth = noticeInner.value.getBoundingClientRect().width;
    
    // 能全部显示不需要滚动
    if (outWidth >= innerWidth) return 0;

    // 这里动态设置动画时间，如果文案名称太长了，就增加滚动时间
    return innerWidth/outWidth * 5000;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "noticeOut",
      ref: noticeOut,
      class: _normalizeClass(['notification_out',]),
      style: _normalizeStyle({animation: `noticeOut${_ctx.MIXIN_LANG=='EG'?'EG':''} ${aDuration.value}ms linear infinite`})
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['notice_inner']),
        ref_key: "noticeInner",
        ref: noticeInner,
        style: _normalizeStyle({animation: `noticeInner${_ctx.MIXIN_LANG=='EG'?'EG':''} ${aDuration.value}ms linear infinite`})
      }, _toDisplayString(_ctx.notice), 5 /* TEXT, STYLE */)
    ], 4 /* STYLE */)
  ]))
}
}

})